import { Card } from '@blockanalitica/ui';
import Activity, { BaseActivityItem } from './Activity';
import ActivityHeatmap from './ActivityHeatmap';
import { ReactNode } from 'react';

interface RecentActivityProps<T extends BaseActivityItem> {
  activityAPIUrl: string;
  heatmapAPIUrl: string;
  linkTo: string;
  activityContentFn?: (item: T) => ReactNode;
}

export default function RecentActivity<T extends BaseActivityItem>({
  activityAPIUrl,
  activityContentFn,
  heatmapAPIUrl,
  linkTo
}: RecentActivityProps<T>) {
  return (
    <Card>
      <Activity
        url={activityAPIUrl}
        linkTo={linkTo}
        contentFn={activityContentFn}
      />
      <ActivityHeatmap url={heatmapAPIUrl} linkTo={linkTo} paddingTop="l" />
    </Card>
  );
}
